export default (arr, len) => {
  let chunks = [];
  let i = 0;
  let n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }

  return chunks;
};



// WEBPACK FOOTER //
// ./src/Common/chunk/index.js